module.exports = __webpack_public_path__ + "img/swap.fcf1d723.svg";